import type { FC, ReactNode } from "react";
import "./style.css";

const PortraitTheme: FC<{ children?: ReactNode }> = ({ children }) => <div>{children}</div>;

export default PortraitTheme;
